import { ProviderUser } from "@/common/types/ProviderUser";
import { LicensesOnboardingForm } from "./LicensesOnboardingForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ProviderOnboardingStep } from "../enums/ProviderOnboardingStep";
import { ONBOARDING_FORM_STYLES as styles } from "./onboarding-form-styles";

interface LicensesOnboardingStepProps {
  providerUser: ProviderUser;
  onComplete: () => void;
  onBack?: () => void;
}

export default function LicensesOnboardingStep({
  providerUser,
  onComplete,
  onBack,
}: LicensesOnboardingStepProps) {
  return (
    <div>
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className={styles.backButton}
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          Back
        </Button>
      )}
      <LicensesOnboardingForm
        onComplete={onComplete}
        userId={providerUser.id}
        hasCompleted={providerUser.onboardingStepsCompleted.some(
          (step) => step.stepId === ProviderOnboardingStep.LICENSES,
        )}
      />
    </div>
  );
}
